import React from 'react';

import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import SectionOne from './components/SectionOne/SectionOne';
import SectionOneMobile from './components/SectionOneMobile/SectionOneMobile';

export default function HomeV2() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // Using 'sm' as the breakpoint for mobile screens

  return <>{isMobile ? <SectionOneMobile /> : <SectionOne />}</>;
}
